module.exports = __webpack_public_path__ + "img/scrum-vision.0e5ad5e0.png";